<template>
  <div>
    <h1 class="text-center mt-10">{{ $t('pageAccept.header') }}</h1>
    <div class="text-center mt-10">{{ $t('pageAccept.description') }}</div>
    <InfoConfirmation />
    <Loader v-if="this.user.loading" />
  </div>
</template>

<script>
import localizationTexts from '@/localization/texts.json';
import InfoConfirmation from '@/components/InfoConfirmation.vue';
import Loader from '@/components/Loader.vue';
import helpers from '@/settings/helpers';
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  name: 'Confirmation',
  components: {
    InfoConfirmation,
    Loader
  },
  beforeMount() {
    if (
      this.user.kilometers > 0 &&
      this.user.car.registrationplate !== undefined &&
      this.user.department.departmentid !== undefined &&
      this.user.services.length > 0 &&
      this.user.datetime.date !== '' &&
      this.user.datetime.arrival !== '' &&
      this.user.info.firstname !== '' &&
      this.user.info.lastname !== '' &&
      this.user.info.address !== '' &&
      this.user.info.zipcode !== '' &&
      this.user.info.city !== '' &&
      this.user.info.email !== '' &&
      this.user.info.phone !== '' &&
      this.user.info.accepted !== ''
    ) {
      this.$store.dispatch('user/initStep', 4);
    } else if (this.user.step === 0) {
      this.$router.push({ name: 'Home' });
    } else if (this.user.step === 1) {
      this.$router.push({ name: 'Service' });
    } else if (this.user.step === 2) {
      this.$router.push({ name: 'Appointment' });
    } else if (this.user.step === 3) {
      this.$router.push({ name: 'Customer' });
    }
  },
  mounted() {
    helpers.sendScroll(this.user.config.container, 0, this.user.config.host);
    this.text.buttonBack = localizationTexts[this.user.config.language].button.back;
    this.text.buttonNext = localizationTexts[this.user.config.language].button.accept;
  },
  data() {
    return {
      text: {
        buttonBack: '',
        buttonNext: ''
      }
    };
  },
  computed: {
    ...mapGetters(['user'])
  }
});
</script>

<style scoped lang="scss"></style>

<i18n src="../localization/texts.json"></i18n>
